<div class="modal-content" *ngIf="controls">
  <div class="modal-header">
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <p *ngIf="!isUpdate" class="modal-title h4" jhiTranslate="modals.addCardToCarousel.title"></p>
    <p *ngIf="isUpdate" class="modal-title h4" jhiTranslate="modals.addCardToCarousel.update.title"></p>
  </div>

  <form>
    <div class="modal-body text-left">
      <div class="row">
        <jhi-bary-input-text [control]="controls.title" [label]="'modals.addCardToCarousel.input.title' | translate" class="col flex-grow-1"> </jhi-bary-input-text>
        <jhi-bary-input-textarea [control]="controls.description" [label]="'modals.addCardToCarousel.input.content' | translate" class="col flex-grow-1"> </jhi-bary-input-textarea>
      </div>
    </div>

    <!--Footer-->
    <div class="modal-footer justify-content-end">
      <jhi-bary-button
        [outline]="true"
        class="mr-3"
        color="primary"
        [label]="'modals.addCardToCarousel.buttons.cancel' | translate"
        (clickEvent)="handleClick({ first: true })"
      ></jhi-bary-button>
      <jhi-bary-button (clickEvent)="handleSubmit()" [label]="setButtonLabel()" color="primary"></jhi-bary-button>
    </div>
  </form>
</div>
